import { Row } from "@tanstack/react-table";

export function customGlobalFilterFn<TData>(
  row: Row<TData>,
  columnId: string,
  filterValue: string,
  countries?: any[],
  developmentStatusMap?: any,
  saleOptionsMap?: any
) {
  const searchValue = filterValue.toLowerCase().trim();
  const originalRow = row.original as any;

  // Search in name
  if (originalRow.name?.toLowerCase().includes(searchValue)) {
    return true;
  }

  // Search in technologies (array of technology names)
  if (originalRow.technologies?.types) {
    const techArray = originalRow.technologies.types;
    if (Array.isArray(techArray) && techArray.some((tech: string) => tech.toLowerCase().includes(searchValue))) {
      return true;
    }
  }

  // Search in capacity
  if (originalRow.technologies?.capacity !== undefined) {
    const capacity = String(originalRow.technologies.capacity);
    if (capacity.includes(searchValue)) {
      return true;
    }
  }

  // Search in development status
  if (originalRow.technologies?.state?.list) {
    const statusList = originalRow.technologies.state.list;
    if (Array.isArray(statusList)) {
      for (const status of statusList) {
        if (status?.toLowerCase().includes(searchValue)) {
          return true;
        }
        if (developmentStatusMap) {
          const mappedStatus = developmentStatusMap(status);
          if (mappedStatus?.toLowerCase().includes(searchValue)) {
            return true;
          }
        }
      }
    }
  }

  // Search in sale options
  if (originalRow.options && Array.isArray(originalRow.options)) {
    for (const option of originalRow.options) {
      if (option?.toLowerCase().includes(searchValue)) {
        return true;
      }
      if (saleOptionsMap) {
        const mappedOption = saleOptionsMap(option);
        if (mappedOption?.toLowerCase().includes(searchValue)) {
          return true;
        }
      }
    }
  }

  // Search in location (countries and cities)
  if (originalRow.location && Array.isArray(originalRow.location)) {
    for (const loc of originalRow.location) {
      if (loc.country) {
        const countryArray = Array.isArray(loc.country) ? loc.country : [loc.country];
        for (const countryCode of countryArray) {
          if (countryCode?.toLowerCase().includes(searchValue)) {
            return true;
          }
          if (countries) {
            const countryObj = countries.find((c: any) => c.value === countryCode);
            if (countryObj?.label?.toLowerCase().includes(searchValue)) {
              return true;
            }
          }
        }
      }

      if (loc.city && Array.isArray(loc.city)) {
        if (loc.city.some((city: string) => city?.toLowerCase().includes(searchValue))) {
          return true;
        }
      }
    }
  }

  return false;
}
